package com.ustadmobile.lib.db.entities.xapi

@Suppress("unused")
object XapiEntityObjectTypeFlags {

    const val AGENT = 1

    const val GROUP = 2

    const val STATEMENT_REF = 3

    const val SUBSTATEMENT = 4

    const val ACTIVITY = 5

    const val STATEMENT = 6


}